module.exports = __webpack_public_path__ + "oh-lottery.png?6561f82362e7b12bede735c607c95a0b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/oh-lottery.png
// module id = 190
// module chunks = 0